import React from 'react';
import { Link } from 'react-router-dom';
import ad from "../../Assests/Bollywood summer camp 2026 details.PNG"; 

const SummerDanceCamp = () => {
  return (
    <div className="bg-white py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">

        {/* ── HERO HEADER ── */}
        <section className="text-center mb-16">
<p className="text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-3">Chilanka Dance School Presents</p>
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-[1px] w-12 bg-[#E40F94]"></div>
            <span className="text-[#E40F94] text-sm">♦ ◇ ♦</span>
            <div className="h-[1px] w-12 bg-[#E40F94]"></div>
          </div>
          <h2 className="text-[42px] md:text-[56px] font-bold text-gray-900 leading-tight mb-4" style={{fontFamily: "'Playfair Display', serif"}}>Chilanka <span className="text-[#E40F94] italic">Summer Dance Camp</span></h2>
          <p className="text-gray-500 text-[16px] mb-6">A Cultural Dance Experience for All Ages</p>
          <div className="w-16 h-[3px] bg-[#E40F94] rounded-full mx-auto mb-8"></div>
          <p className="text-lg text-gray-600 mb-4">
            Calling all Girls and Boys for A Fun & <span className="text-[#E40F94] font-semibold">Enriching Cultural Experience!</span>
          </p>
          <p className="text-lg text-gray-600 mb-4">
            Wondering what to do this summer with your kids? Give them the gift of Indian dance, creativity, and cultural exploration at Chilanka Dance School's Summer Camp, <span className="font-bold text-gray-900">June 8–12, 2026!</span>
          </p>
          <p className="text-lg text-gray-600 mb-4">
            Our summer dance camp invites children from every background to explore Indian dance — a high-energy, expressive, and entertaining art form that sparks creativity and fosters self-expression. Designed for both newcomers and young performers alike, our camp offers a week of engaging dance lessons, creative activities, and fun interactions.
          </p>
          <p className="text-lg text-gray-600">
            Join us for a summer adventure where dance becomes a window to a world of creativity and cultural appreciation!
          </p>
        </section>

        {/* ── FLYER IMAGE ── */}
        <div className="flex items-center justify-center mb-16">
          <div className="group relative overflow-hidden rounded-2xl shadow-2xl">
            <img
              className="w-[420px] rounded-2xl transition-transform duration-500 group-hover:scale-105"
              src={ad}
              alt="Summer Camp 2026 Flyer"
            />
            <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity duration-300 rounded-2xl"></div>
          </div>
        </div>

        {/* ── WHAT TO EXPECT ── */}
        <section className="mb-16">
          <div className="text-center mb-10">
            <p className="text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-3">What's Included</p>
            <h3 className="text-[36px] font-bold text-gray-900 leading-tight">What to Expect</h3>
            <div className="w-16 h-[3px] bg-[#E40F94] rounded-full mx-auto mt-4"></div>
          </div>
          <div className="grid grid-cols-1 pt-4 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="group bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 text-center border border-gray-100">
              <div className="text-3xl mb-3">💃</div>
              <h4 className="text-[18px] font-bold text-gray-900 mb-2">Daily Dance Workshops</h4>
              <p className="text-gray-500 text-[15px] leading-relaxed">Learn Bollywood, Bhangra, Garba, and classical dance styles from expert instructors.</p>
            </div>
            <div className="group bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 text-center border border-gray-100">
              <div className="text-3xl mb-3">🎭</div>
              <h4 className="text-[18px] font-bold text-gray-900 mb-2">Fun Activities</h4>
              <p className="text-gray-500 text-[15px] leading-relaxed">Storytelling, music appreciation, and creative movement to make learning even more fun!</p>
            </div>
            <div className="group bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 text-center border border-gray-100">
              <div className="text-3xl mb-3">🎨</div>
              <h4 className="text-[18px] font-bold text-gray-900 mb-2">Arts & Crafts</h4>
              <p className="text-gray-500 text-[15px] leading-relaxed">Hands-on projects inspired by Indian culture, including crafting dance props and exploring henna art.</p>
            </div>
            <div className="group bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 text-center border border-gray-100">
              <div className="text-3xl mb-3">⭐</div>
              <h4 className="text-[18px] font-bold text-gray-900 mb-2">Confidence & Expression</h4>
              <p className="text-gray-500 text-[15px] leading-relaxed">Build stage presence and self-confidence through interactive sessions.</p>
            </div>
            <div className="group bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 text-center border border-gray-100">
              <div className="text-3xl mb-3">🎬</div>
              <h4 className="text-[18px] font-bold text-gray-900 mb-2">Mini Performance</h4>
              <p className="text-gray-500 text-[15px] leading-relaxed">Campers showcase what they've learned in a special end-of-week mini performance for parents.</p>
            </div>
          <div className="group bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 text-center border border-gray-100">
              <div className="text-3xl mb-3">🌟</div>
              <h4 className="text-[18px] font-bold text-gray-900 mb-2">Open to All Levels</h4>
              <p className="text-gray-500 text-[15px] leading-relaxed">No experience needed! Our camp welcomes beginners and experienced dancers ages 5–15 from all different backgrounds.</p>
            </div>
          </div>
        </section>

        {/* ── CTA BANNER ── */}
        <section className="relative overflow-hidden bg-[#E40F94] rounded-2xl px-8 py-12 text-center mb-16 shadow-xl">
          <div className="relative z-10">
            <p className="text-[13px] uppercase tracking-[5px] text-pink-200 font-semibold mb-3">Don't Miss Out</p>
            <h3 className="text-[36px] font-bold text-white leading-tight mb-3">Spaces are Limited!</h3>
            <div className="w-16 h-[3px] bg-white rounded-full mx-auto mb-6"></div>
            <p className="text-white text-lg mb-2">Register now to give your child a summer filled with dance, culture, and creativity.</p>
            <p className="text-pink-200 text-[15px] mb-1">🐣 <span className="line-through">Early Bird: <span className="text-white font-bold">$275</span> (through May 15)</span></p>
            <p className="text-pink-200 text-[15px] mb-4">🎟️ Regular Price: <span className="text-white font-bold">$300</span></p>
            <p className="text-pink-200 text-[13px]">Sibling discount: $25 off each additional child</p>
          </div>
        </section>

{/* ── JOTFORM REGISTRATION ── */}
        <section id="register" className="mb-16">
          <div className="text-center mb-10">
            <p className="text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-3">Join Us This Summer</p>
            <h3 className="text-[36px] font-bold text-gray-900 leading-tight">Register Now</h3>
            <div className="w-16 h-[3px] bg-[#E40F94] rounded-full mx-auto mt-4 mb-2"></div>
            <p className="text-gray-500 text-[15px] mt-4">Complete the form below to register and pay securely in one step.</p>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl">
            <iframe
              id="JotFormIFrame-261077735131050"
              title="Summer Camp 2026 Registration Form"
              allowTransparency="true"
              allow="geolocation; microphone; camera; fullscreen; payment"
              src="https://pci.jotform.com/form/261077735131050"
              frameBorder="0"
              style={{minWidth:'100%', maxWidth:'100%', height:'1200px', border:'none'}}
              scrolling="yes"
            >
            </iframe>
          </div>
          <p className="text-center text-gray-400 text-[13px] mt-4">🔒 Payments secured by Square · All information is encrypted</p>
        </section>

      </div>
    </div>
  );
};

export default SummerDanceCamp;
